import { boot } from 'quasar/wrappers'
import VueScrollTo from 'vue-scrollto'

export default boot(({ app }) => {
  app.use(VueScrollTo)
})
